import type { JSX } from "react";

import { Pill } from "@mantine/core";

export function LobBadge({ lob }: { lob: string }): JSX.Element | null {
    return (
        <Pill data-testid="lob-tag" size="md" radius="sm" bg="dark.3" fw="var(--mantine-font-weight-heavy)">
            {lob}
        </Pill>
    );
}
